import { Table } from '@chakra-ui/react'
import type { FC } from 'react'

interface Props {
  headers: Record<string, string>
}

const PreviewTableHeader: FC<Props> = ({ headers }) => (
  <Table.Header>
    <Table.Row>
      {Object.keys(headers).map((key) => (
        <Table.ColumnHeader key={key}>{headers[key]}</Table.ColumnHeader>
      ))}
    </Table.Row>
  </Table.Header>
)

export default PreviewTableHeader
